module.exports = __webpack_public_path__ + "img/16.ea9fd19c.jpg";